"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const axios_1 = __importDefault(require("axios"));
const floating_vue_1 = require("floating-vue");
const ProjectAssociation_vue_1 = __importDefault(require("./ProjectAssociation.vue"));
const trans_1 = require("@common/tsutils/trans");
let SandboxExampleGenerator = class SandboxExampleGenerator extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.enableAction = false;
        this.sending = false;
        this.result = {};
        this.status = '';
        this.showingModal = false;
        this.steps = [1, 2, 3];
        this.maxSubclients = 3;
        this.data = {
            clientCode: '',
            clientName: '',
            randomClientCode: true,
            clientIsDistributor: true,
            projects: void [],
            subclients: [],
        };
        this.currentStep = 0;
    }
    enableButton() {
        this.enableAction = true;
    }
    get title() {
        if ('success' === this.status) {
            return (0, trans_1.trans)("super.sandboxGeneration.success-title");
        }
        else if ('error' === this.status || 'unexpected_error' === this.status) {
            return (0, trans_1.trans)("super.sandboxGeneration.error-title");
        }
        return (0, trans_1.trans)("super.sandboxGeneration.waiting-title");
    }
    get subtitle() {
        if ('unexpected_error' === this.status) {
            return (0, trans_1.trans)("super.sandboxGeneration.error-caption");
        }
        else {
            if ('error' === this.status) {
                return this.result.error_message;
            }
        }
        return (0, trans_1.trans)("super.sandboxGeneration.waiting-caption");
    }
    get pendingSubclient() {
        return this.maxSubclients - this.data.subclients.length;
    }
    get test() {
        return this.data.subclients.length;
    }
    get isLastStep() {
        return this.currentStep === this.steps.length - 1;
    }
    created() {
        this.data.projects = [];
    }
    addSubclient() {
        let client = {
            clientCode: '',
            clientName: '',
            randomClientCode: true,
            projects: []
        };
        // this.data.subclients.push(new ClientT());
        this.data.subclients.push(client);
    }
    nextStep() {
        if (this.currentStep < this.steps.length - 1)
            this.currentStep++;
    }
    prevStep() {
        if (this.currentStep > 0)
            this.currentStep--;
    }
    submitForm() {
        // alert(`Formulario enviado: ${JSON.stringify(this.formData.value, null, 2)}`)
    }
    addProject(client) {
    }
    deleteSubClient(index) {
        this.data.subclients.splice(index, 1);
    }
    closeModal() {
        this.showingModal = false;
        if ('success' === this.status) {
            this.data = {
                clientCode: '',
                clientName: '',
                randomClientCode: true,
                clientIsDistributor: true,
                projects: [],
                subclients: [],
            };
        }
        this.status = '';
    }
    sendRequest() {
        const url = '/super/sandbox/demo/clients/create';
        const data = Object.assign({}, this.data);
        data.subclients = data.clientIsDistributor ? data.subclients : [];
        data.clientCode = data.randomClientCode ? '' : data.clientCode;
        data.subclients.forEach(subclient => {
            subclient.clientCode = subclient.randomClientCode ? '' : subclient.clientCode;
        });
        // console.log({data});
        // if (!this.enableAction || this.sending) return;
        this.sending = true;
        this.showingModal = true;
        axios_1.default.post(url, data)
            .then(response => this.successGeneration(response.data))
            .catch(error => this.errorGeneration(error))
            .finally(() => this.sending = false);
    }
    successGeneration(data) {
        this.status = data.status;
        this.result = data;
    }
    errorGeneration(error) {
        this.status = 'error';
        if (error.response) {
            // Server responded with a status code outside the range of 2xx
            console.error('Error generating example:', error.response.data);
        }
        else if (error.request) {
            // Request was made but no response received
            console.error('No response received:', error.request);
        }
        else {
            // Something else happened during setup
            console.error('Error setting up request:', error.message);
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SandboxExampleGenerator.prototype, "raw_user", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SandboxExampleGenerator.prototype, "templates", void 0);
SandboxExampleGenerator = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            FullsizeTemplate: bmk_ui_framework_1.FullsizeTemplate,
            Modal: bmk_ui_framework_1.Modal,
            Inbox: lucide_vue_next_1.Inbox,
            Button: bmk_ui_framework_1.Button,
            ArrowLeft: lucide_vue_next_1.ArrowLeft,
            ProjectAssociation: ProjectAssociation_vue_1.default,
            Dropdown: floating_vue_1.Dropdown
        }
    })
], SandboxExampleGenerator);
exports.default = SandboxExampleGenerator;
